import { render, staticRenderFns } from "./MailChannel.vue?vue&type=template&id=627e78b6"
import script from "./MailChannel.vue?vue&type=script&lang=js"
export * from "./MailChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports